/**---------------------------------------------------------------------
 * Load in production only
 */

import _ from 'lodash';

if (Mobi2Go.app.base_url === 'https://www.mobi2go.com') {
    Mobi2Go.onReady(load);
}

function load() {
    const { Order } = Mobi2Go;
    const { Analytics } = Mobi2Go;
    const E = Analytics.EVENTS;

    /**---------------------------------------------------------------------
     * Install script
     */
    const segment_key = Mobi2Go.headoffice.analytics_segment_key;

    if (!segment_key) {
        return;
    }

    !(function() {
        const analytics = (window.analytics = window.analytics || []);
        if (!analytics.initialize)
            if (analytics.invoked)
                window.console &&
                    console.error &&
                    console.error('Segment snippet included twice.');
            else {
                analytics.invoked = !0;
                analytics.methods = [
                    'trackSubmit',
                    'trackClick',
                    'trackLink',
                    'trackForm',
                    'pageview',
                    'identify',
                    'group',
                    'track',
                    'ready',
                    'alias',
                    'page',
                    'once',
                    'off',
                    'on',
                ];
                analytics.factory = function(t) {
                    return function() {
                        const e = Array.prototype.slice.call(arguments);
                        e.unshift(t);
                        analytics.push(e);
                        return analytics;
                    };
                };
                for (let t = 0; t < analytics.methods.length; t++) {
                    const e = analytics.methods[t];
                    analytics[e] = analytics.factory(e);
                }
                analytics.load = function(t) {
                    const e = document.createElement('script');
                    e.type = 'text/javascript';
                    e.async = !0;
                    e.src = `${
                        document.location.protocol === 'https:'
                            ? 'https://'
                            : 'http://'
                    }cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`;
                    const n = document.getElementsByTagName('script')[0];
                    n.parentNode.insertBefore(e, n);
                };
                analytics.SNIPPET_VERSION = '3.0.1';
                analytics.load(segment_key);
                analytics.page();
            }
    })();

    /**---------------------------------------------------------------------
     * Abstraction
     */
    function identify(customer) {
        if (customer) {
            analytics.identify(customer.id, {
                email: customer.email,
                name: customer.name,
                firstName: customer.getFirstName(),
                lastName: customer.getLastName(),
                phone: customer.phone_number,
            });
        }
    }

    function viewedProductCategory(category) {
        analytics.track('Viewed Product Category', {
            category: category.name,
        });
    }

    function viewedProduct(menu_product) {
        analytics.track('Viewed Product', {
            id: menu_product.id,
            name: menu_product.name,
            sku: menu_product.plu,
            price: menu_product.price,
            category: menu_product.category.name,
        });
    }

    function addedProduct(product) {
        analytics.track('Added Product', _convertProduct(product));
    }

    function removedProduct(product) {
        if (Order.isResetting()) {
            return;
        }
        analytics.track('Removed Product', _convertProduct(product));
    }

    function startedCheckout() {
        analytics.track('Started Checkout', _convertOrder());
    }

    function completedOrder() {
        analytics.track('Completed Order', _convertOrder());
    }

    function _convertOrder() {
        return {
            orderId: Order.getId(),
            total: Order.getTotal().toFloat(),
            revenue: Order.getTotal()
                .getTaxExclusivePrice()
                .toFloat(),
            shipping: Order.getDeliveryFee().toFloat(),
            tax: Order.getTotal()
                .getTaxPrice()
                .toFloat(),
            discount: Order.getDiscountsTotal().toFloat(),
            coupon: Order.getVoucherCode(),
            currency: Mobi2Go.headoffice.currency_abrv,
            products: _.map(Order.getProducts(), _convertProduct),
        };
    }

    function _convertProduct(product) {
        return {
            id: product.menu_product.id,
            name: product.menu_product.name,
            sku: product.menu_product.plu,
            price: product.price.toFloat(),
            quantity: product.quantity,
            category: product.menu_product.category.name,
        };
    }

    /**---------------------------------------------------------------------
     * Application Glue
     */

    Analytics.bind({
        IDENTIFY_CUSTOMER(customer) {
            identify(customer);
        },
        VIEWED_PRODUCT_MENU(menu) {
            viewedProductCategory(menu);
        },
        VIEWED_PRODUCT_CATEGORY(menu_category) {
            viewedProductCategory(menu_category);
        },
        ADDED_PRODUCT(product) {
            addedProduct(product);
        },
        EDITED_PRODUCT(product) {
            viewedProduct(product.menu_product);
        },
        REMOVED_PRODUCT(product) {
            removedProduct(product);
        },
        STARTED_CHECKOUT: startedCheckout,
        CONFIRMED_ORDER: completedOrder,
    });
}
